export const FETCH = 'news/FETCH';
export const FETCH_SUCCESS = 'news/FETCH_SUCCESS';
export const FETCH_ERROR = 'news/FETCH_ERROR';
